(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class HeaderMenuOverflow {
    constructor(nav) {
      this.nav = nav;
      this.list = nav.querySelector(':scope > .list-menu--inline');
      this.overflowItem = null;
      this.overflowList = null;
      this.mediaQuery = window.matchMedia('(min-width: 750px)');

      if (!this.list) return;

      this.createOverflowMenu();
      this.handleResize = this.debounce(this.update.bind(this), 100);
      window.addEventListener('resize', this.handleResize);
      this.mediaQuery.addEventListener('change', this.update.bind(this));
      requestAnimationFrame(() => this.update());
    }

    createOverflowMenu() {
      this.overflowItem = document.createElement('li');
      this.overflowItem.className = 'header__menu-overflow-item';
      this.overflowItem.innerHTML = `
        <header-menu>
          <details class="header__menu-overflow">
            <summary class="header__menu-item list-menu__item link focus-inset" tabindex="0">
              <span>More</span>
              <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708Z" fill="currentColor"></path>
              </svg>
            </summary>
            <ul class="header__submenu header__menu-overflow-list list-menu list-menu--disclosure color-${this.getMenuColorScheme()} gradient caption-large motion-reduce global-settings-popup" role="list"></ul>
          </details>
        </header-menu>
      `;
      this.overflowList = this.overflowItem.querySelector('.header__menu-overflow-list');
      this.list.appendChild(this.overflowItem);
    }

    getMenuColorScheme() {
      return this.nav.dataset.menuColorScheme || 'scheme-1';
    }

    restoreItems() {
      const movedItems = Array.from(this.overflowList.children);
      movedItems.forEach((item) => this.list.insertBefore(item, this.overflowItem));
      this.overflowItem.querySelector('details').classList.remove('is-visible');
    }

    update() {
      if (!this.mediaQuery.matches) {
        this.restoreItems();
        return;
      }

      this.restoreItems();

      const details = this.overflowItem.querySelector('details');
      const directItems = () => Array.from(this.list.children).filter((item) => item !== this.overflowItem);

      if (this.list.scrollWidth <= this.nav.clientWidth) return;

      details.classList.add('is-visible');

      while (this.list.scrollWidth > this.nav.clientWidth && directItems().length > 1) {
        const items = directItems();
        const itemToMove = items[items.length - 1];
        this.overflowList.insertBefore(itemToMove, this.overflowList.firstChild);
      }

      if (this.overflowList.children.length === 0) {
        details.classList.remove('is-visible');
      }
    }

    debounce(callback, wait) {
      let timeout;
      return (...args) => {
        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => callback(...args), wait);
      };
    }
  }

  document.querySelectorAll('.header__inline-menu').forEach((nav) => new HeaderMenuOverflow(nav));

  } catch(e) { console.error(e); }
})();
})();
